import HotelCardLabel from './HotelCardLabel';

export default HotelCardLabel;
